<template lang="html">
    <table class="table team-members">
        <thead>
            <tr>
                <th></th>
                <th>Name</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="member in currentTeam.users">
                <td><img class="spark-profile-photo" :src="member.photo_url" :alt="member.name"></td>
                <td>{{ member.name }}</td>
                <td class="manage">
                    <button class="btn btn-primary-outline" v-if="currentlyAssigned(member)" @click="dissociateMember(member)">
                        <span class="fa fa-check"></span>
                    </button>
                    <button class="btn btn-default-outline" v-else @click="assignMember(member)">
                        <span class="fa fa-plus"></span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('client', {
            'client': 'activeClient',
            'isAdmin': 'isAdmin',
            'currentTeam': 'currentTeam',
        })
    },

    methods: {
        currentlyAssigned(user) {
            return this.client.team_members.filter(member => member.id === user.id).length > 0;
        },

        assignMember(member) {
            this.$store.dispatch('client/assignMember', {
                member: member
            }).then()
                .catch(response => {
                    if (response.status !== 422) {
                        Bus.$emit('show-error-alert', response.data.message);
                    }
                });
        },

        dissociateMember(member) {
            this.$store.dispatch('client/dissociateMember', {
                member: member
            }).then()
            .catch(response => {
                if (response.status !== 422) {
                    Bus.$emit('show-error-alert', response.data.message);
                }
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/clients/ManageTeamMembersForm.vue